/* __next_internal_client_entry_do_not_use__ Portugal auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13%3A357))
 * @trackcomponent
 * @lastsynced 2023-11-30T15:50:24.786Z
 */ export var Portugal = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "1",
            width: "16",
            height: "12",
            fill: "#B64343"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "1",
            width: "6",
            height: "12",
            fill: "#64804E"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "1",
            width: "16",
            height: "12",
            stroke: "#757575"
        }),
        /*#__PURE__*/ _jsx("circle", {
            cx: "6.5",
            cy: "6.5",
            r: "3",
            fill: "#B64343",
            stroke: "#FFD464"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 5H5V6.99993C5 6.99996 5 6.99998 5 7C5 7.55228 5.67157 8 6.5 8C7.32843 8 8 7.55228 8 7C8 6.99998 8 6.99996 8 6.99993V5Z",
            fill: "white"
        })
    ]
}), "Portugal", function(strictLocalize) {
    return {
        viewBox: "0 0 18 14",
        fill: "none",
        titleAccess: strictLocalize({
            id: "8plqS8",
            defaultMessage: [
                {
                    type: 0,
                    value: "Portugal flag"
                }
            ]
        })
    };
});
